// extracted by mini-css-extract-plugin
export default {"share-button-container":"MbJ7a","share-button":"w8xtw","qr":"QblVm"};